export default "__VITE_ASSET__DlhW60v0__"